import { memo } from 'react';

import { ProseList } from '@/components/ui/prose/prose.list';
import type { ColumnWidth } from '@/components/ui/table/columnWidth';
import { getByPath } from '@/utils/widgets';
import type { WidgetData } from '../../widget.type';
import type { ListView } from './list.type';

type Props = {
  view: ListView;
  data: WidgetData;
};

const ListViewImpl = memo(({ view, data }: Props) => {
  const { path, ordered, small, light } = view;

  if (light) {
    console.warn('light is deprecated for list view');
  }

  const listData = getByPath<string[]>(data, path);
  if (!listData) return null;

  return (
    <ProseList
      className="text-card-foreground"
      items={listData}
      ordered={ordered}
      small={small}
    />
  );
});

// sort defaults to length on path
const getSortConfig = (view: ListView) => ({
  type: 'length',
  path: view.path
});

// filtering defaults to text search on path
const getFilterConfig = (view: ListView) => ({
  type: 'text',
  path: view.path
});

// width defaults to 'large'
const getDefaultWidth = (): ColumnWidth => 'large';

// stringifies data at path
const getStringifyFunction = (view: ListView) => {
  const { path } = view;
  return (data: WidgetData) => {
    const listData = getByPath<string[]>(data, path);
    if (!listData) return '';

    return listData.join(', ');
  };
};

export const listViewProvider = {
  component: ListViewImpl,
  getSortConfig,
  getFilterConfig,
  getDefaultWidth,
  getStringifyFunction
};
